// removed by extract-text-webpack-plugin
module.exports = {"NewConversationButton":"NewConversationButton__DCdm8","NewConversationText":"NewConversationText__1b89Q","NewConversationWrapper":"NewConversationWrapper__2OEOT"};


//////////////////
// WEBPACK FOOTER
// ./routes/Chat/NewConversationButton/style.scss
// module id = 1SMb
// module chunks = 0